import * as React from "react";
const SvgFiRrPingPong = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ping-pong_svg__a)">
      <path
        fill="#062147"
        d="M21.261 2.739A9.836 9.836 0 0 0 8.3 2.114a4.489 4.489 0 1 0-4.166 6.849 9.4 9.4 0 0 0 .842 5.668.5.5 0 0 1-.07.564L2 16.945a3.743 3.743 0 0 0 2.192 7.028 3.7 3.7 0 0 0 2.725-1.735l2.068-3.127a.5.5 0 0 1 .575-.089 9.66 9.66 0 0 0 11.315-2.147A10.5 10.5 0 0 0 24 9.758a9.4 9.4 0 0 0-2.739-7.019M2 4.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m8.44 12.726a2.494 2.494 0 0 0-3.017.632 1 1 0 0 0-.067.09l-2.127 3.218a1.742 1.742 0 1 1-2.89-1.94 1.76 1.76 0 0 1 .642-.538l3.041-1.831a1 1 0 0 0 .126-.09 2.49 2.49 0 0 0 .623-3.016 7.33 7.33 0 0 1-.693-4.259l8.433 8.433a7.3 7.3 0 0 1-4.071-.699m9.021-1.765a8.9 8.9 0 0 1-2.732 1.865c-.009-.01-.012-.023-.022-.033L7.36 7.945A4.47 4.47 0 0 0 9 4.5c0-.119-.026-.231-.035-.347a8.01 8.01 0 0 1 10.882 0A7.42 7.42 0 0 1 22 9.7a8.5 8.5 0 0 1-2.539 5.761"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ping-pong_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPingPong;
